export default {
  namespaced: true,
  state: () => ({
    firstPath: null
  }),
  mutations: {
    setFirstPath(state, firstPath) {
      state.firstPath = firstPath;
    }
  },
  actions: {
    updateFirstPath({ commit }, firstPath) {
      commit("setFirstPath", firstPath);
    }
  },
  getters: {
    getFirstPath: state => state.firstPath
  }
};
